import { defineComponent, PropType } from "vue";
import { Overlay } from "vant";
import Lottie from "~mall/components/lottie/index.vue";
import { getStylesBinder } from "~mall/common/utils/styles";
import styles from "./index.module.less";

const cx = getStylesBinder(styles);

interface DiscountItem {
  name: string;
  amount: number;
}

interface DiscountsRes {
  discountsList: DiscountItem[];
  describe: string;
}

export default defineComponent({
  name: "FirstDiscountsDialogNew",
  components: {
    Overlay,
    Lottie,
  },
  props: {
    showFirstDiscountsDialog: {
      type: Boolean,
      default: false,
    },
    discountsRes: {
      type: Object as PropType<DiscountsRes>,
      default: () => ({
        discountsList: [],
        describe: "",
      }),
    },
    onHandleClick: {
      type: Function as PropType<() => void>,
      default: undefined,
    },
  },
  setup: (props, { emit }) => {
    const handleClick = () => {
      emit("handleClick");
    };

    return () => (
      <Overlay
        class={cx("first-discounts-dialog-view-new")}
        show={props.showFirstDiscountsDialog}
        lock-scroll={false}
        z-index="99999"
      >
        <div class={cx("first-discounts-dialog-wrap")}>
          {props.showFirstDiscountsDialog && (
            <transition name="bounce">
              <div class={cx("first-discounts-dialog")}>
                <div class={cx("lottie-container")}>
                  <Lottie
                    url="https://m.hellobike.com/resource/helloyun/11929/GZn6Ik1VkF.json"
                    name="lottie-top-img"
                  />
                </div>
                <img
                  class={cx("first-discounts-dialog-img")}
                  src="https://oho-image-cdn.51downapp.cn/common/b2a87764870846a4906ab418a9891213_ride-card-40.png"
                  alt=""
                />
                <div class={cx("content-container")}>
                  <div class={cx("first-discounts-list")}>
                    {props.discountsRes.discountsList?.map((item) => (
                      <div key={item.name} class={cx("list-item")}>
                        <div class={cx("item-price")}>
                          <span class={cx("item-price-num")}>
                            {item.amount}
                          </span>
                          元
                        </div>
                        <div class={cx("item-title")}>{item.name}</div>
                      </div>
                    ))}
                  </div>
                  <div
                    class={cx("first-discounts-btn-block")}
                    onClick={handleClick}
                  >
                    {props.discountsRes.describe}
                  </div>
                  <img
                    class={cx("everyday-close")}
                    src="https://oho-image-cdn.51downapp.cn/common/a33d813521dd452ca7cbb8e594dc3d79_ride-card-41.png"
                    alt=""
                    onClick={handleClick}
                  />
                </div>
              </div>
            </transition>
          )}
        </div>
      </Overlay>
    );
  },
});
